import { defineComponent as _defineComponent } from 'vue'
import { onBeforeMount, onBeforeUnmount, ref } from 'vue'
import { emitter } from '@/plugins/emitter'


export default /*#__PURE__*/_defineComponent({
  __name: 'PrivateRelayWarningDialog',
  setup(__props) {

/**
 * Apple Private Relay 警告（vue-final-modal）。
 * open は mitt（show-private-relay-warning）。未移行 hub 発火は emitter forward。
 */
const SHOW_PRIVATE_RELAY_WARNING = 'show-private-relay-warning'

const visible = ref(false)
const onProceed = ref<(() => void) | null>(null)

function show(callback?: (() => void) | null) {
  onProceed.value = callback || null
  visible.value = true
}

function close() {
  onProceed.value = null
  visible.value = false
  emitter.emit('loading_off')
}

function onVisibleInput(value: boolean) {
  if (value) {
    visible.value = true
    return
  }
  if (!visible.value) return
  onProceed.value = null
  visible.value = false
  emitter.emit('loading_off')
}

function proceed() {
  const callback = onProceed.value
  onProceed.value = null
  visible.value = false
  if (callback) {
    callback()
  }
}

onBeforeMount(() => {
  emitter.on(SHOW_PRIVATE_RELAY_WARNING, show)
})

onBeforeUnmount(() => {
  emitter.off(SHOW_PRIVATE_RELAY_WARNING, show)
})

return { __sfc: true,SHOW_PRIVATE_RELAY_WARNING, visible, onProceed, show, close, onVisibleInput, proceed }
}

})